/**
 * @typedef {string} Permission
 * */

/**
 * @enum {Permission}
 */
export default {
    CreateCustomer: 'CreateCustomer',
    UpdateCustomer: 'UpdateCustomer',
    CreateFamily: 'CreateFamily',
    UpdateFamily: 'UpdateFamily',
    CreateApplication: 'CreateApplication',
    UpdateApplication: 'UpdateApplication',
    CreateStatMetadata: 'CreateStatMetadata',
    UpdateStatMetadata: 'UpdateStatMetadata',
    CreateInstance: 'CreateInstance',
    UpdateInstance: 'UpdateInstance',
    CreateStatRecord: 'CreateStatRecord',
    UpdateStatRecord: 'UpdateStatRecord',
    CreateStatGroup: 'CreateStatGroup',
    CreateTemporaryTable: 'CreateTemporaryTable',
    UpdateClient: 'UpdateClient',
    RunQuery: 'RunQuery',
    ManageRoles: 'ManageRoles',
    CreateExtension: 'CreateExtension',
};
